import React from 'react'
import { t } from '@lingui/core/macro'
import styles from './ErrorPage.module.css'

const NotFoundPage = () => {
    return (
        <div className={styles.section}>
            <div className={styles.iconWrapper}>
                <div className={styles.number404}>404</div>
            </div>

            <h1 className={styles.title}>{t`Страница не найдена`}</h1>
            <p className={styles.description}>
                {t`К сожалению, запрашиваемая страница не существует или была удалена.`}
            </p>
        </div>
    )
}

export default NotFoundPage
